import { LOADING_STATUS } from '@sonifi/wb-core/common/Constants';
import apiService from '@sonifi/wb-core/services/api.service';
import { ENDPOINTS } from '@sonifi/wb-core/services/endpointsConstants';
import { buildApiUri, parseQueryParams } from '@sonifi/wb-core/utils/parseHelper';
import {
  setLoadingOrder,
  setLoadingOrders,
  setOrder,
  setOrders,
} from '../../store/orders/irdOrdersSlice';
import {
  setExpandedRow,
  setTablePagination,
} from '@sonifi/wb-widget/store/tableConfig/tableConfigSlice';
import { TABLE_KEYS } from '@sonifi/wb-widget/store/tableConfig/tableConfigConstants';
import configurationService from '@sonifi/wb-core/services/configuration.service';
import oauthService from '@sonifi/wb-login/services/oauth.service';

const getOrderSourceLabel = (order) =>
  order.source === 'STAYCONNECT' ? 'Mobile' : 'TV';

export const getIrdOrders =
  ({
    page = 1,
    pageSize = 100,
    query,
    revenueCenterId,
    sortBy = 'created',
    sortDir = 'desc',
  } = {}) =>
  async (dispatch, getState) => {
    const {
      groups: { selectedGroup },
    } = getState();

    const params = {
      _query: query,
      group: selectedGroup.uri,
      _order_by: `${sortDir === 'desc' ? '-' : ''}${sortBy}`,
      page,
      rpp: pageSize,
      revenue_center_id: revenueCenterId,
    };

    try {
      dispatch(setLoadingOrders(LOADING_STATUS.loading));
      const url = `${ENDPOINTS.IRD_ORDERS}?${parseQueryParams(params)}`;
      const res = await apiService.get(url);
      const orders = res.data?.objects || [];
      dispatch(
        setTablePagination({
          query,
          page,
          pageSize,
          sortBy,
          sortDir,
          total: res.data.total,
          tableKey: TABLE_KEYS.irdOrders,
        }),
      );

      dispatch(setOrders({ orders }));
      dispatch(setLoadingOrders(LOADING_STATUS.success));
    } catch (error) {
      console.error(error);
      dispatch(setLoadingOrders(LOADING_STATUS.error));
    }
  };

export const getIrdOrderById =
  ({ id, revenueCenterId }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoadingOrder(LOADING_STATUS.loading));
      dispatch(setOrder({ order: null }));
      const {
        groups: { selectedGroup },
      } = getState();
      const url = `${ENDPOINTS.IRD_ORDERS}/${id}`;
      const res = await apiService.get(url);
      const orderRes = res.data;

      const irdItems = orderRes.ird_items.map((item) => ({
        ...item,
        ird_category: orderRes._embedded[item.ird_category],
        ird_item: orderRes._embedded[item.ird_item],
        option_sets: item.option_sets.map((os) => ({
          ...os,
          options: os.options.map((op) => ({
            ...op,
            ird_item: orderRes._embedded[op.ird_item],
          })),
        })),
      }));

      const order = {
        ...orderRes,
        ird_items: irdItems,
        revenue_center_id: revenueCenterId,
        orderSource: getOrderSourceLabel(orderRes),
        group: selectedGroup,
      };

      dispatch(setOrder({ order }));
      dispatch(setLoadingOrder(LOADING_STATUS.success));
    } catch (error) {
      console.error(error);
      dispatch(setLoadingOrder(LOADING_STATUS.error));
    }
  };

export const exportirdOrdersCsv = (groupId) => {
  const oauthCredentials = configurationService.get('oauthCredentials');
  if (oauthCredentials.resourceOwner) {
    const base = configurationService.get('apiUri');
    const options = oauthCredentials;
    options.params = { rpp: -1 };
    const exportLink = oauthService.buildOAuthUri(
      'GET',
      buildApiUri(base, 'groups', groupId, 'ird_orders.csv'),
      false,
      options,
    );
    window.open(exportLink, '_blank');
  }
};

export const initRowExpanded = (id) => async (dispatch, getState) => {
  const {
    irdOrders: { orders },
  } = getState();
  const orderIndex = orders.findIndex((o) => o.id === parseInt(id));

  dispatch(
    setExpandedRow({
      expanded: orderIndex !== -1 ? { [orderIndex]: true } : {},
      tableKey: TABLE_KEYS.irdOrders,
    }),
  );
};
